import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  SectionContainer,
} from './AuditSeven.style';

const AuditSeven = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditSeven.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <div className="grid-content">
            <h2>{t('auditSeven.subtitleOne')}</h2>
            <p>{t('auditSeven.paragraphOne')}</p>
          </div>
          <div className="grid-content">
            <h2>{t('auditSeven.subtitleTwo')}</h2>
            <p>{t('auditSeven.paragraphTwo')}</p>
          </div>
          <div className="grid-content">
            <h2>{t('auditSeven.subtitleThree')}</h2>
            <p>{t('auditSeven.paragraphThree')}</p>
          </div>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditSeven;
